// Third-party packages
import * as configcat from 'configcat-js';

// Project modules
import {
	Destination,
} from '@local_types/index';

// Relative imports
import {
	FEATURE_FLAGS_DESTINATION_NAME,
} from '../config/destinations';


const envToConfigCatKey: Record<string, string> = {
	dev: 'configcat-sdk-1/Zb7ZCFBilkCElftCAYinVQ/F44XBC5hwEmcDN87SOkj9g',
	prod: 'configcat-sdk-1/Zb7ZCFBilkCElftCAYinVQ/M0sHZPWVt0--E2QCYiKuyA',
	staging: 'configcat-sdk-1/Zb7ZCFBilkCElftCAYinVQ/t0E7mMWVek6BSylfglHhjg',
	test: 'configcat-sdk-1/Zb7ZCFBilkCElftCAYinVQ/F44XBC5hwEmcDN87SOkj9g',
};


export class FeatureFlags implements Destination {
	name: string = FEATURE_FLAGS_DESTINATION_NAME;

	private client: configcat.IConfigCatClient;

	constructor(env: 'dev' | 'test' | 'staging' | 'prod') {
		this.client = configcat.getClient(
			envToConfigCatKey[env],
			configcat.PollingMode.LazyLoad,
			{
				cacheTimeToLiveSeconds: 600,
				logger: configcat.createConsoleLogger(configcat.LogLevel.Info),
			});
		this.parseQueryParams();
	}

	identify(userId: string | undefined, traits: any) {
		if (userId) {
			this.client.setDefaultUser({
				custom: traits,
				email: traits?.email,
				identifier: userId,
			});
		}
	}

	private parseQueryParams() {
		const queryParams = new URLSearchParams(window.location.search);
		// Copy all stn_ff_* query params to localStorage
		for (const [
			key,
			value,
		] of queryParams.entries()) {
			if (key.startsWith('stn_ff_')) {
				window.localStorage.setItem(key, value);
			}
		}
	}

	async isFeatureEnabled(feature: string, defaultValue: boolean = false, localOnly: boolean = false) {
		if (window.localStorage) {
			const localValue = window.localStorage.getItem('stn_ff_'+feature);
			if (localValue === 'true' || localValue === 'false') {
				return localValue === 'true';
			}
		}
		if (localOnly) {
			return defaultValue;
		}
		return await this.client.getValueAsync(feature, defaultValue);
	}
}
